@if (mode() === StepperMode.HORIZONTAL) {
  <div class="flex flex--row stepper" data-testid="stepper">
    @for (step of steps(); track step; let last = $last; let index = $index) {
      <div
        role="tablist"
        [class.ms-xxsmall-r]="!last"
        [ngClass]="{
          'align-center center flex-1 flex--basis0': showLabels(),
        }"
      >
        <button
          role="tab"
          (click)="selectStep($event, step)"
          [attr.aria-label]="step.ariaLabel | finLocalization"
          [class.inverted]="theme() === StepperTheme.DARK"
          [disabled]="index > activeStep()"
        >
          @if (showLabels()) {
            <span
              [ngClass]="{
                'nordic-blue-100-text text-icon-disabled-text regular-type':
                  index > activeStep() && theme() === StepperTheme.LIGHT,
                'nordic-blue-300-text': index > activeStep() && theme() === StepperTheme.DARK,
              }"
              [class.white-text]="theme() === StepperTheme.DARK"
              [class.text-icon-reversed]="theme() === StepperTheme.DARK"
              [class.medium-type]="index <= activeStep()"
              class="block ps-small-b font-body-small"
              >{{ step.title | finLocalization }}</span
            >
          }
          <div class="atom inline-block rounded-large ps-xxsmall-y ps-xxlarge-l center"></div>
        </button>
      </div>
    }
  </div>
}
@if (mode() === StepperMode.RADIAL) {
  <div class="flex flex--middle" data-testid="stepper">
    @if (showLabels()) {
      <div
        class="ps-xsmall-r font-body-medium-bold"
        [class.nordic-blue-400-text]="theme() === StepperTheme.LIGHT"
        [class.text-icon-secondary]="theme() === StepperTheme.LIGHT"
        [class.white-text]="theme() === StepperTheme.DARK"
        [class.text-icon-reversed]="theme() === StepperTheme.DARK"
        data-testid="stepper-title"
      >
        {{ steps()?.[activeStep()]?.title || steps()?.[activeStep()]?.ariaLabel | finLocalization }}
      </div>
    }
    <div class="progress relative" [class]="theme()">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="(activeStep() / steps().length) * 100"
      >
        <circle class="progress-bg" cx="24" cy="24" r="22" stroke-width="4" fill="none" />
        <circle
          class="progress-circle"
          cx="24"
          cy="24"
          r="22"
          stroke-width="4"
          fill="none"
          stroke-dasharray="138.23"
          stroke-linecap="round"
          [attr.stroke-dashoffset]="(1 - (activeStep() + 1) / steps().length) * 138.23"
          transform="rotate(-90 24 24)"
          id="progress-circle-bar"
        />
      </svg>
      <div
        class="progress-text absolute z1 nordic-blue-900-text text-icon-primary font-body-medium-bold"
        data-testid="stepper-progress"
      >
        {{ activeStep() + 1 }}/{{ steps().length }}
      </div>
    </div>
  </div>
}
